import { ThemeProvider as MaterialThemeProvider } from '@mui/material';

import { theme } from './theme';
import { ThemeProviderProps } from './ThemeProvider.types';

export const ThemeProvider = ({ children }: ThemeProviderProps) => (
  <MaterialThemeProvider theme={theme}>{children}</MaterialThemeProvider>
);
